import { GetPageProps, UserRegistrationState } from 'hooks/u002/useUserRegistrationHooks';
import { PageContent } from 'templates/PageContent';
import { Form } from 'templates/Form';
import { TermsParser } from 'organisms/u002/TermsParser';
import { TransitionButton } from 'atoms/TransitionButton';
import { Button } from 'atoms/Button';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { AppLogoHeader } from 'templates/AppLogoHeader';
import { UnauthAppFooter } from 'templates/UnauthAppFooter';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useRef, useState, useEffect } from 'react';

type UnderThirteenGuidanceProps = GetPageProps<UserRegistrationState, 'UnderThirteenGuidance'>;
export const UnderThirteenGuidance: React.FC<UnderThirteenGuidanceProps> = (props) => {
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');
  const handleBack = () => props.onBack();
  const handleNext = () => props.onNext();
  const [checked, setChecked] = useState(false);
  const [isScrolledToEnd, setIsScrolledToEnd] = useState(false);
  const termsRef = useRef<HTMLDivElement>(null);

  const handleChange = (checked: boolean) => {
    setChecked(checked);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (termsRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = termsRef.current;
        if (scrollTop + clientHeight >= scrollHeight - 1) {
          setIsScrolledToEnd(true);
        }
      }
    };

    const checkScrollable = () => {
      if (termsRef.current) {
        const { scrollHeight, clientHeight } = termsRef.current;
        if (scrollHeight <= clientHeight) {
          setIsScrolledToEnd(true);
        }
        handleScroll();
      }
    };

    const termsElement = termsRef.current;
    if (termsElement) {
      const resizeObserver = new ResizeObserver(checkScrollable);
      resizeObserver.observe(termsElement);
      termsElement.addEventListener('scroll', handleScroll);
      checkScrollable();

      return () => {
        resizeObserver.disconnect();
        termsElement.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return (
    <>
      <AppLogoHeader />
      <PageContent>
        <Form title={tAuditionForm('TU002_092')}>
          <div
            className="max-h-96 overflow-y-scroll"
            ref={termsRef}
            aria-label={tAuditionForm('TU002_092')}
            tabIndex={0}
          >
            <TermsParser text={tAuditionForm('TU002_093')} />
          </div>

          <FormControlLabel
            control={
              <Checkbox
                color="secondary"
                checked={checked}
                onChange={(e) => handleChange(e.target.checked)}
                disabled={!isScrolledToEnd}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                    setChecked(!checked);
                  }
                }}
                aria-required="true"
              />
            }
            label={tAuditionForm('TU002_136')}
            className="text-[--c-text] flex justify-center items-center"
          />

          <div className={'flex justify-center items-center'}>
            <TransitionButton
              label={tAuditionForm('TU002_048')}
              onClick={handleBack}
              className="w-[10rem] mr-6"
            />
            <Button
              label={tAuditionForm('TU002_047')}
              className={'w-[10rem]'}
              onClick={handleNext}
              disabled={!checked}
            />
          </div>
        </Form>
      </PageContent>
      <UnauthAppFooter />
    </>
  );
};
